import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "layout-main__container" }
const _hoisted_2 = { class: "layout-main__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")
  const _component_router_view = _resolveComponent("router-view")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TheSidebar = _resolveComponent("TheSidebar")
  const _component_Toast = _resolveComponent("Toast")

  return (_openBlock(), _createBlock("div", {
    class: ["layout-main", [_ctx.routeName, _ctx.showSidebar ? 'has--sidebar' : null]]
  }, [
    _createVNode(_component_TheHeader, { class: "layout-main__header" }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_ElScrollbar, null, {
        default: _withCtx(() => [
          _createVNode("main", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      }),
      (_ctx.showSidebar)
        ? (_openBlock(), _createBlock(_component_TheSidebar, {
            key: 0,
            class: "layout-main__nav"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_Toast, {
        position: "top-center",
        class: "layout-main__toasts"
      })
    ])
  ], 2))
}